/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded MonitorHeart.
 * @export
 */
export const ICON_MONITOR_HEART = (
  <svg height="24" viewBox="0 0 24 20" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.6283 10.5248L14.3333 7.9465L10.7049 15.1915C10.5183 15.5882 10.1099 15.8332 9.66658 15.8332C9.22325 15.8332 8.81492 15.5882 8.62825 15.1915L6.60992 11.1665H0.333252V16.9998C0.333252 18.2832 1.38325 19.3332 2.66659 19.3332H21.3333C22.6166 19.3332 23.6666 18.2832 23.6666 16.9998V11.1665H16.6666C16.2233 11.1665 15.8149 10.9215 15.6283 10.5248Z" />
    <path d="M21.3333 0.666504H2.66659C1.38325 0.666504 0.333252 1.7165 0.333252 2.99984V8.83317H7.33325C7.77659 8.83317 8.18492 9.07817 8.37159 9.47484L9.66658 12.0532L13.2949 4.80817C13.6916 4.01484 14.9866 4.01484 15.3833 4.80817L17.3899 8.83317H23.6666V2.99984C23.6666 1.7165 22.6166 0.666504 21.3333 0.666504Z" />
  </svg>
);
